import { createRouter, createWebHistory } from 'vue-router'
import { appendDirLocal } from '@/config.js'
import NotFound from '@/components/NotFound.vue'
import qs from 'qs'

const router = createRouter({
  history: createWebHistory(appendDirLocal),
  routes: [
    {
      path: '/customdb',
      name: 'Customdb',
      component: () => import('@/components/Customdb.vue')
    },
    {
      path: '/customdb-edit/:cdb_table_id',
      name: 'CustomdbEdit',
      props: (route) => ({ cdbTableId: typeof route.params.cdb_table_id !== 'undefined' ? parseInt(route.params.cdb_table_id) : null }),
      component: () => import('@/components/CustomdbEdit.vue')
    },
    {
      path: '/dispatch-list',
      name: 'DispatchList',
      component: () => import('@/components/DispatchList.vue')
    },
    {
      path: '/dispatch-list/:dispatch_id',
      name: 'DispatchEdit',
      props: (route) => ({ routerProp: typeof route.params.dispatch_id !== 'undefined' ? route.params.dispatch_id : '' }),
      component: () => import('@/components/DispatchList.vue')
    },
    {
      path: '/dispatch-list/dispatch-settings',
      name: 'DispatchSettings',
      props: { routerProp: 'dispatch-settings' },
      component: () => import('@/components/DispatchList.vue')
    },
    {
      path: '/form-edit',
      name: 'FormBuilder',
      component: () => import('@/components/FormBuilder.vue'),
      alias: ['/form-excel-import', '/FormClone/:cloneToken?', '/form-ai-generation']
    },
    {
      path: '/frequent/:form_id?/:form_name?',
      name: 'FillWrap',
      component: () => import('@/components/FillWrap.vue'),
      alias: ['/response/:token?', '/Event-Editor/', '/event/:token?/:token2?']
    },
    {
      path: '/Form-List',
      name: 'FillWrapForm',
      component: () => import('@/components/FillWrap.vue')
    },
    {
      path: '/Trigger-Edit',
      name: 'TriggerEdit',
      props: (route) => ({
        triggerId: typeof route.query.trigger_id !== 'undefined' ? parseInt(route.query.trigger_id) : null,
        routerProp: {
          tab: route.query.tab,
          input_name: route.query.input_name,
          form_id: parseInt(route.query.form_id)
        }
      }),
      component: () => import('@/components/TriggerEdit.vue')
    },
    {
      path: '/settings_pdf_custom',
      name: 'CustomPdfLayoutImport',
      component: () => import('@/components/CustomPdfLayoutImport.vue')
    },
    {
      path: '/Automated-Tests',
      name: 'AutomatedTestsList',
      component: () => import('@/components/AutomatedTestsList.vue')
    },
    {
      path: '/Statistics-Dashboard',
      name: 'StatisticsDashboardList',
      component: () => import('@/components/StatisticsDashboardList.vue')
    },
    {
      path: '/Statistics-Dashboard/:member_option_id',
      name: 'StatisticsDashboard',
      props: (route) => ({ memberOptionId: typeof route.params.member_option_id !== 'undefined' && route.params.member_option_id !== 'new' ? parseInt(route.params.member_option_id) : 0 }),
      component: () => import('@/components/StatisticsDashboard.vue')
    },
    {
      path: '/Sales-Dashboard',
      name: 'SalesDashboard',
      component: () => import('@/components/SalesDashboard.vue')
    },
    {
      path: '/Report-Detail',
      name: 'ReportDetailCrossroads',
      component: () => import('@/components/ReportDetailCrossroads.vue'),
      props: (route) => {
        const componentName = route.query.component && ['ChartSettings', 'FillWrap'].includes(route.query.component) ? route.query.component : 'NotFound'
        if (componentName === 'NotFound') {
          window.vue._container.dispatchEvent(new Event('route-not-found', { bubbles: true, cancelable: true }))
        }
        return ({
          component: componentName,
          userData: {
            formId: route.query.id ? Number(route.query.id) : 0,
            resultType: route.query.result_type ?? 'form',
            membersEventId: route.query.members_event_id ? Number(route.query.members_event_id) : 0,
            eventId: route.query.event_id ? Number(route.query.event_id) : 0,
            locationReloadAfterSave: route.query.location_reload_after_save && route.query.location_reload_after_save === '1'
          }
        })
      }
    },
    {
      path: '/Chart-Edit/:member_option_id?',
      name: 'ChartEdit',
      component: () => import('@/components/ChartEdit.vue'),
      props: (route) => ({ memberOptionId: route.params.member_option_id && !isNaN(route.params.member_option_id) ? parseInt(route.params.member_option_id) : 0 })
    },
    { path: '/404', component: NotFound },
    { path: '/:pathMatch(.*)*', component: NotFound }
  ],
  parseQuery (query) {
    return qs.parse(query)
  },
  stringifyQuery (query) {
    return qs.stringify(query) || ''
  }
})

router.beforeEach((to, from) => {
  if (to.name === 'ReportDetailCrossroads' && !to.query.component) {
    history.pushState(history.state, '', window.correct_url + to.fullPath.replace(/^\//, ''))
    window.$('.event_boxes').slideDown()
    window.$('#form_list').slideDown()
    window.$('#forms-list').slideDown()
    window.$('#event_editor').slideUp()
    window.$('#reports_filters-column').show()
    window.$('#event_editor #root').remove()
    window.unmountVueIfDefined()
    return false
  }
  return true
})

export default router
